module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/setting/departments/departments-show/departments-show.component.scss
// module id = ./src/app/views/setting/departments/departments-show/departments-show.component.scss
// module chunks = main